export default __webpack_public_path__ + "static/ogimage-f0d4651102081047248c8645ab6dabd5.jpg";